import styles from './style.postcss';

import React, { PureComponent } from 'react';
import Linkify from 'linkifyjs/react';
import { Button, Dialog } from 'omni-common-ui';
import PropTypes from 'prop-types';
import SkillRecommendationExpandPanel from './SkillRecommendationExpandPanel';

export default class SkillRecommendation extends PureComponent {
  constructor() {
    super();
    this.state = {
      isDialogOpen: false,
      selectedRecommendationItemIds: [],
    };
    this._checkRecommendationItem = this._checkRecommendationItem.bind(this);
  }

  componentWillMount() {
    this.setState({ selectedRecommendationItemIds: this.props.selectedRecommendationItemIds });
  }

  _checkRecommendationItem(id) {
    let { selectedRecommendationItemIds } = this.state;
    if (selectedRecommendationItemIds.includes(id)) {
      selectedRecommendationItemIds = selectedRecommendationItemIds.filter((selectedId) =>
          selectedId !== id);
    } else {
      selectedRecommendationItemIds = [...selectedRecommendationItemIds, id];
    }
    this.setState({ selectedRecommendationItemIds });
  }

  _onOkClick() {
    this.props.onRecommendationChanged(this.state.selectedRecommendationItemIds);
    this.setState({ isDialogOpen: false });
  }

  _onCancelClick() {
    this.setState({
      isDialogOpen: false,
      selectedRecommendationItemIds: this.props.selectedRecommendationItemIds,
    });
  }

  _onClickEditActionPlan() {
    this.setState({
      isDialogOpen: true,
      selectedRecommendationItemIds: this.props.selectedRecommendationItemIds,
    });
  }

  _renderPopup(recommendationItems) {
    const recommendationItemsGroupByCategoryName =
      recommendationItems.groupBy((recommendationItem) => recommendationItem.categoryName);
    const { selectedRecommendationItemIds } = this.state;
    return <Dialog isOpen={this.state.isDialogOpen}
        className={styles.SkillRecommendation_popup}
        paddingless>
      <div className={styles.SkillRecommendation_popup_content}>
        {recommendationItemsGroupByCategoryName.map((categoryItems) =>
          <SkillRecommendationExpandPanel categoryName={categoryItems.first().categoryName}
              isSSV3Group={this.props.isSSV3Group}
              recommendationItems={categoryItems}
              selectedRecommendationItemIds={selectedRecommendationItemIds}
              checkRecommendationItem={this._checkRecommendationItem} />
        )}
      </div>
      <Button.Container className={styles.SkillRecommendation_popup_buttons}>
        <Button onClick={() => this._onCancelClick()}>Cancel</Button>
        <Button type={Button.Type.primary}
            onClick={() => this._onOkClick()} >Ok</Button>
      </Button.Container>
    </Dialog>;
  }

  _renderSelectedRecommendationItems(recommendationItems, selectedRecommendationItemIds) {
    const selectedrecommendationItems = recommendationItems.filter((recommendationItem) =>
      selectedRecommendationItemIds.includes(recommendationItem.id));
    return <div className={styles.SkillRecommendation_container}>
      {
        ! this.props.isInEditMode &&
          <div className={styles.SkillRecommendation_subHeading}>Suggestions</div>
      }
      {
        selectedrecommendationItems.map((selectedrecommendationItem) =>
          <div key={selectedrecommendationItem.id} className={styles.SkillRecommendation_item}>
            <Linkify>
              {selectedrecommendationItem.itemName}
            </Linkify>
          </div>)
      }
      {
        ! this.props.isInEditMode &&
          <div className={styles.SkillRecommendation_item}>{this.props.suggestion}</div>
      }
    </div>;
  }

  render() {
    const {
      selectedRecommendationItemIds,
      skillRecommendations,
      skillId,
      isInEditMode,
      isMissing,
      showEditButton,
    } = this.props;

    if (! skillRecommendations.keySeq().includes(`${skillId}`)) return null;

    const recommendationItems = skillRecommendations.get(`${skillId}`).skillRecommendationItems;
    return <div>
      {this._renderSelectedRecommendationItems(recommendationItems, selectedRecommendationItemIds)}
      {isInEditMode && showEditButton &&
        <Button className={styles.SkillRecommendation_editButton}
            type={isMissing ? Button.Type.wrong : Button.Type.default}
            onClick={() => this._onClickEditActionPlan()}>
          Edit action plan
        </Button>}
      {this._renderPopup(recommendationItems)}
    </div>;
  }

}

SkillRecommendation.propTypes = {
  skillRecommendations: PropTypes.shape(),
  skillId: PropTypes.number,
  suggestion: PropTypes.string,
  isSSV3Group: PropTypes.bool,
  isInEditMode: PropTypes.bool.isRequired,
  selectedRecommendationItemIds: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
  onRecommendationChanged: PropTypes.func,
  isMissing: PropTypes.bool,
  showEditButton: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/FeedbackSuggestions/SkillSuggestionCard/SkillRecommendation/index.jsx